import styled from 'styled-components';

export const ContainerHorLine = styled.div`
  margin: 24px 0 40px 0;
  padding: 24px 20px 28px;
  box-shadow: 2px 8px 40px rgba(15, 23, 42, 0.2);
  border-radius: 30px;
  background: ${p => p.theme.colors.main.white};
  border: 1px solid ${p => p.theme.colors.main.grayLight};
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  align-items: stretch;
`;

/** Область под ResizeObserver и график Victory с шириной 100% */
export const ChartMeasureInner = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

/**
 * Родитель с тем же соотношением сторон, что и логический canvas Victory.
 * От responsive-SVG через viewBox даёт только равномерный scale → шрифты не «расплющены».
 */
export const ChartVictoryWrap = styled.div`
  width: 100%;
  min-width: 0;
  position: relative;
  aspect-ratio: ${p =>
    typeof p.$aspectW === 'number' &&
    typeof p.$aspectH === 'number' &&
    p.$aspectW > 0 &&
    p.$aspectH > 0
      ? `${p.$aspectW} / ${p.$aspectH}`
      : '450 / 300'};

  > .VictoryContainer {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;
